<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Bill Settings'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>

    @if (loaded) {
      <tidy-card>
        <tidy-row class="field-bottom-padding">
          <form [formGroup]="form">
            <tidy-input
              formControlName="email"
              [label]="'Email to send bills to'"
              [form]="form.controls.email"
              type="email"
              [submitted]="submitted"
              [errorMessage]="'Please enter a valid email.'"
              [icon]="'assets/svg/mail.svg'" />
          </form>
        </tidy-row>
      </tidy-card>
      <tidy-button
        [text]="'Save Changes'"
        [action]="save.bind(this)"
        class="primary" />
    }

    <tidy-error-message
      [text]="errorMessage" />

  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
